<template>
    <div class="card__header" :style="{ textAlign: align }">
        <h3 v-if="module.mainTitle" class="card__title"
            :style="{ fontSize: fontSize, fontWeight: fontWeight, cursor: (module.linkUrl && !module.linkText) ? 'pointer' : 'default' }"
            @click="handleClick(module.linkUrl)">{{
                module.mainTitle }}</h3>
        <p v-if="module.subTitle" class="card__subtitle">{{ module.subTitle }}</p>
        <a v-if="module.linkText" :href="getHref(module.linkUrl)" class="card__link"
            @click.prevent="handleClick(module.linkUrl)">{{ module.linkText }}</a>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { Module, PortalPositionEnum } from '@/api/page_config';
import { getHref, jumpToUrl } from '@/utils/url';
const props = defineProps<{
    module: Module;
}>();

const align = computed(() => {
    switch (props.module.position) {
        case PortalPositionEnum.Left:
            return 'left'
        case PortalPositionEnum.Right:
            return 'right'
        case PortalPositionEnum.Center:
            return 'center'
        default:
            return 'center'
    }
})
const fontWeight = computed(() => {
    return props.module.isBold ? '800' : '400'
})

const fontSize = computed(() => {
    return props.module.fontSize ? `${props.module.fontSize}px` : '1.75rem'
})

const handleClick = (url: string): void => {
    jumpToUrl(url)
}

</script>

<style lang="scss" scoped>
.card__header {
    text-align: center;
    margin-bottom: 2rem;

    @media (min-width: $breakpoint-md) {
        margin-bottom: 2.75rem;
    }
}

.card__title {
    font-size: 1.75rem;
    font-weight: 800;
    color: $color-text;
    margin: 0 0 0.5rem;
    letter-spacing: -0.02em;

    @media (min-width: $breakpoint-md) {
        font-size: 2.25rem;
        margin-bottom: 0.75rem;
    }
}

.card__subtitle {
    font-size: 0.875rem;
    color: $color-text-secondary;
    margin: 0;
    line-height: 1.6;

    @media (min-width: $breakpoint-md) {
        font-size: 1rem;
    }
}

.card__link {
    font-size: 0.875rem;
    color: $color-primary;
    margin-top: 0.5rem;

    @media (min-width: $breakpoint-md) {
        font-size: 1rem;
    }
}
</style>